import { BsClock, BsMap, BsPen } from 'react-icons/bs';
import { cartHelper, helpers } from 'src/services';
import { CartPointCrud } from './CartPointCrud';
import { CartPointEnabledPeriod } from './CartPointEnabledPeriod';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { typeCartsDoc, typeCartPoint } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    cartsDoc: typeCartsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const CartPoint: FC<propsType> = ({ cartsDoc, setRefreshCounter }) => {
    const [pointToEdit, setPointToEdit] = useState<typeCartPoint | null>(null);
    const [showForm, setShowForm] = useState(false);
    const [showPeriodsFromPointId, setShowPeriodsFromPointId] = useState(0);
    const isDarkMode = useGetIsDarkMode();

    useEffect(() => {
        helpers.GoToTop();
    }, [pointToEdit, showForm, showPeriodsFromPointId]);

    return (
        <div className={'container mt-3'} style={{ maxWidth: '850px' }}>
            <div className={'mb-3'}>
                <h3 className={`text-center flex-grow-1 ${isDarkMode ? 'text-white' : ''} mt-2`}>
                    {!showForm ? 'PUNTOS' : pointToEdit ? 'EDITAR PUNTO' : 'AGREGAR PUNTO'} <BsMap className={'mb-2'} />
                </h3>
            </div>

            {!showForm &&
                <>
                <div className={'row'}>
                    {cartsDoc.points?.filter(p => !p.wasDeleted && (!showPeriodsFromPointId || showPeriodsFromPointId === p.id)).map(point =>
                        <div key={point.id} className={'col-12 mb-4'}>
                            <div className={`card ${isDarkMode ? 'bg-dark text-white border-light' : ''}`}>
                                <div className={'card-body'}>
                                    <h5 className={'card-title border-bottom pb-3'}>
                                        {point.name.toUpperCase()}
                                    </h5>
                                    <div className={'card-text mb-2'}>
                                        Dirección: {point.address}
                                    </div>
                                    <div className={'card-text mb-2'}>
                                        Punto de retiro: {point.pickupCartPoint}
                                    </div>
                                    <div>
                                        <div className={'mb-1'}>
                                            Horarios habilitados:
                                        </div>
                                        <ul>
                                            {point.enabledPeriods
                                             .sort((ep1, ep2) => (ep1.startHour - ep2.startHour) || (ep1.endMinutes - ep2.startMinutes))
                                             .map(ep =>
                                                <li key={ep.id}>
                                                    {cartHelper.GetTimeFromPeriodData(ep.startHour, ep.startMinutes, ep.endHour, ep.endMinutes)}
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                {showPeriodsFromPointId === point.id &&
                                    <CartPointEnabledPeriod
                                        goBack={() => setShowPeriodsFromPointId(0)}
                                        point={point}
                                        setRefreshCounter={setRefreshCounter}
                                    />
                                }
                                {!showPeriodsFromPointId &&
                                    <div className={`card-footer d-flex gap-2 justify-content-end ${isDarkMode ? 'border-light' : ''}`}>
                                        <button className={'btn btn-yellow btn-sm text-white'}
                                            onClick={() => setShowPeriodsFromPointId(x => x ? 0 : point.id)}
                                        >
                                            <BsClock className={'me-2'} />
                                            Editar Horarios Habilitados
                                        </button>
                                        <button className={'btn btn-general-red btn-sm'}
                                            onClick={() => {
                                                setPointToEdit(point);
                                                setShowForm(true);
                                            }}
                                        >
                                            Editar <BsPen />
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    )}
                </div>
                {!showPeriodsFromPointId &&
                    <div className={'text-center mb-5'}>
                        <button className={`btn btn-general-${showForm ? 'red' : 'blue'}`}
                            onClick={() => {
                                setShowForm(true);
                                setShowPeriodsFromPointId(0);
                                setPointToEdit(null);
                            }}
                        >
                            Agregar punto
                        </button>
                    </div>
                }
                </>
            }

            {showForm &&
                <CartPointCrud
                    pointToEdit={pointToEdit}
                    setPointToEdit={setPointToEdit}
                    setRefreshCounter={setRefreshCounter}
                    setShowForm={setShowForm}
                />
            }
        </div>
    )
}
